module.exports = __webpack_public_path__ + "img/2.8db42417.png";